import React from 'react'
import { Grid, Button, Typography, Container, Chip, Card, CardContent, Table, TableBody, TableRow, TableCell, IconButton, CircularProgress } from '@material-ui/core'
import { AccountCircleOutlined, AllInboxOutlined, LocationOnOutlined, ShoppingCartOutlined, LocalActivity, AccountBalanceOutlined, CreditCardOutlined, AccountBalanceWalletOutlined } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { functions } from '../../utils/firebase'
import { connect } from 'react-redux'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash'
import smallLogo from '../Nav/mobileLogo.webp'
import Cart from './Cart'
import OffersPopUp from '../Widget/OffersPopUp'
import AddNewAddress from '../Profile/AddNewAddress'
import { createOrder } from '../../actions/orderAction'
import { addAddress } from '../../actions/userAction'
import { setLocation, openUpdateProfileModal, closeUpdateProfileModal } from '../../actions/metaAction'



const generateOrder = functions.httpsCallable('generateOrder')

const useStyles = makeStyles((theme) => ({
    loadingScreen: {
        position: 'fixed',
        top: '0px',
        left: '0px',
        overflow: 'hidden',
        zIndex: '99',
        height: '100vh',
        width: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    root: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // backgroundColor: "#f7f7f7"
    },
    marginTop: {
        marginTop: theme.spacing(1)
    },
    card: {
        marginBottom: '10px',
        borderRadius: '20px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& >*': {
            marginRight: theme.spacing(1)
        }
    },
    paymentDiv: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        '& >*': {
            marginRight: theme.spacing(1)
        },
        [theme.breakpoints.only('xs')]: {
            flexDirection: 'column',
            '&>*': {
                marginRight: 0,
                marginTop: theme.spacing(1)
            }
        }
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    coupon: {
        border: `1px dashed ${theme.palette.text.secondary} `,
        borderRadius: '1000px',
        padding: '8px 11px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    couponRemove: {
        marginLeft: theme.spacing(1),

    },
    discount: {
        color: theme.palette.success.main
    },
    payable: {
        borderTop: `1px solid ${theme.palette.text.secondary} `
    }
}));

const CustomTableCell = withStyles(theme => ({
    root: {
        width: "calc(100%/2)",
        padding: "5px 10px",
        border: "0"
    },
    sizeSmall: {
        color: theme.palette.text.secondary,
        paddingLeft: '15px',
    }
}))(TableCell);



const CheckOut = (props) => {

    // const __DEV__ = document.domain === 'localhost'

    const [state, setState] = React.useState({
        scriptLoaded: false,
        address: {},
        selectedAddressId: null,
        gst: 5.0,
        packagingCharge: 30.00,
        deliveryCharge: 30.00,
        promoCode: '',
        promoId: '',
        discount: 0,
        payable: 0

    })

    const [orderData, setOrderData] = React.useState({})
    const [isVerifying, setVerifying] = React.useState(false)

    const [isOpen, toggle] = React.useState(false)
    const [isAddressOpen, addressToggle] = React.useState(false)

    const price = Number(props.price)
    const isPorfileComplete = props.isPorfileComplete
    const classes = useStyles()

    function updatePrice(forPirce, promoCode, promoId, discount = 0) {
        const { gst, packagingCharge, deliveryCharge } = state
        if (forPirce) {
            const payable = Number(price) + Number(price * gst) / 100 + Number(packagingCharge) + Number(deliveryCharge)
            setState(current => {
                return {
                    ...current,
                    payable,
                    discount: 0,
                    promoCode: '',
                    promoId: ''
                }
            })
        } else {
            let discountPrice = Number(price) - Number(discount)
            discountPrice = discountPrice <= 0 ? 0 : discountPrice
            const payable = Number(discountPrice) + Number(price * gst) / 100 + Number(packagingCharge) + Number(deliveryCharge)
            setState(current => {
                return {
                    ...current,
                    payable,
                    discount,
                    promoCode,
                    promoId
                }
            })
        }
    }

    function loadScript() {
        const script = document.createElement('script')
        script.src = "https://checkout.razorpay.com/v1/checkout.js"
        script.onload = () => {
            // console.log('loaded')
            setState(current => {
                return {
                    ...current,
                    scriptLoaded: true
                }
            })
        }
        script.onerror = () => {
            return window.alert('Payment Gateway failed to load. Are you online?')
        }
        document.body.appendChild(script)
    }

    function handleAddress(deliveryAddress) {

        props.setLocation({
            location: deliveryAddress.address,
            coordinates: {
                lat: deliveryAddress.coordinates.lat,
                lng: deliveryAddress.coordinates.lng
            }
        })

        setState((current) => {
            return {
                ...current,
                address: {
                    address: deliveryAddress.address,
                    doorNumber: deliveryAddress.doorNumber,
                    landmark: deliveryAddress.landmark,
                    phoneNumber: deliveryAddress.phoneNumber,
                    coordinates: {
                        lat: deliveryAddress.coordinates.lat,
                        lng: deliveryAddress.coordinates.lng
                    },
                    label: deliveryAddress.label,
                    name: ""
                },
                selectedAddressId: deliveryAddress.id
            }
        })

        addressToggle(false)

    }

    function getOrderFromServer() {
        const payloadData = {
            promoId: state.promoId
        }

        if (!price) {
            return
        }
        return generateOrder(payloadData).then(response => {
            const { order } = response.data
            // console.log(order);
            setOrderData(order)
        }).catch(error => {
            // console.log(error);
            if (error.message && error.message !== "INTERNAL") {
                window.alert(error.message)
            } else {
                window.alert('something went wrong, please try again after sometime.')
            }
        })
    }

    React.useEffect(() => {
        updatePrice(true)
        const { scriptLoaded } = state
        if (!scriptLoaded) {
            loadScript()
        }

        window.scrollTo(0, 0)

        // ============================================
        // generating new order everytime price is updated i.e. cart updated 
        // ============================================
        getOrderFromServer()


    }, [price])

    // ======================================
    // generating order everytime promocode is changed
    // ======================================
    const promoId = state.promoId
    React.useEffect(() => {
        getOrderFromServer()
    }, [promoId])


    React.useEffect(() => {
        if (isPorfileComplete) {
            props.closeUpdateProfileModal()
        } else {
            props.openUpdateProfileModal()
        }

    }, [isPorfileComplete])


    // ===============================================
    // Place order starts here
    // ===============================================

    async function placeOrder(isOnlineMode) {

        if (!isPorfileComplete) {
            props.openUpdateProfileModal()
            return
        }

        setVerifying(true)


        const payloadData = {
            promoId: state.promoId
        }

        const response = await generateOrder(payloadData)
        const { order } = response.data

        setVerifying(false)

        const orderOutlet = props.outlets[props.meta.nearestOutlet.id]
        let promoCode = null
        if (state.promoId) {
            promoCode = props.promoCodes[state.promoId]
            delete promoCode['createdAt']
            delete promoCode['updatedAt']
        }
        const payload = {
            uid: props.uid,
            deliveryLocationInfo: {
                ...state.address
            },
            deliveryPerson: {
                name: null,
                phone: null,
                userId: null,
                vehicalDetails: null
            },
            deliveryPersonAssigned: false,
            orderCart: {
                ...props.cart
            },
            orderLive: true,
            orderOutlet: {
                outletId: orderOutlet.id,
                outletName: orderOutlet.outletName,
                address: orderOutlet.address,
                email: orderOutlet.email,
                phone: orderOutlet.phone,
                owner: orderOutlet.owner,
                isOpen: orderOutlet.isOpen
            },
            orderUser: {
                userName: props.profile.full_name,
                userMobile: props.profile.phoneNumber,
                userId: props.uid,
                userImg: props.profile.photoURL
            },
            paymentDetails: {
                ...order.notes,
                orderId: order.id,
                paymentId: '',
                signature: '',
                itemPrice: Number(props.price).toFixed(2),
                orderAmount: Number(state.payable).toFixed(2),
                paymentMode: "cash",
                paymentStatus: 'Success',
                promoCode,
                refund: false,
                refundAmount: 0
            },
            status: 'ORDER_PLACED'
        }


        if (isOnlineMode) {
            const options = {
                key: process.env.REACT_APP_RAZOR_PAY_LIVE_KEY_ID,
                currency: order.currency,
                amount: order.amount,
                order_id: order.id,
                name: 'Desi Cooks',
                description: `Your order for ${props.qty} items`,
                image: smallLogo,
                handler: function (response) {

                    payload.paymentDetails.orderId = response.razorpay_order_id
                    payload.paymentDetails.paymentId = response.razorpay_payment_id
                    payload.paymentDetails.signature = response.razorpay_signature
                    payload.paymentDetails.paymentMode = "online"

                    // console.log(payload);
                    // debugger

                    props.createOrder(payload)
                },
                "theme": {
                    "color": "#ffb933"
                }
            }

            const rzp1 = new window.Razorpay(options);
            rzp1.open();
        } else {
            props.createOrder(payload)
        }

    }

    // ===============================================
    // Place order ends here
    // ===============================================



    // ===============================================
    // UI starts here
    // ===============================================

    return (
        <div>
            {isVerifying && <div className={classes.loadingScreen} >
                <CircularProgress color="secondary" />
                <Typography component="p" variant="body1" align="center" color="secondary" >
                    Verifying your order
                </Typography>
            </div>}

            <Container className={classes.root}>

                <Grid container spacing={4} >

                    {/* ================================================== */}
                    {/* 1st column starts here */}
                    {/* ================================================== */}

                    <Grid item xs={12} sm={8}>
                        <Card variant="outlined" className={classes.card} >
                            <CardContent>
                                <Typography component="div" variant="h6" align="left" color="primary" >
                                    <div className={classes.row}>
                                        <AccountCircleOutlined /> <span> Account</span>
                                    </div>
                                </Typography>
                                <Typography component="p" variant="body1" align="left" color="textSecondary" >
                                    {props.profile.full_name} | {props.profile.phoneNumber}
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card variant="outlined" className={classes.card} >
                            <CardContent>
                                <Typography component="div" variant="h6" align="left" color="primary" >
                                    <div className={classes.row}>
                                        <AllInboxOutlined /> <span> Delivery Time</span>
                                    </div>
                                </Typography>
                                <Typography component="p" variant="body1" align="left" color="textSecondary" >
                                    Your order will be delivered within <strong> 45 minutes</strong>
                                </Typography>
                            </CardContent>
                        </Card>

                        {/* ================================================== */}
                        {/* Address thing starts here */}
                        {/* ================================================== */}

                        <Card variant="outlined" className={classes.card} >
                            <CardContent>
                                <Grid container justify="space-between">
                                    <Grid item xs={8}>
                                        <Typography component="div" variant="h6" align="left" color="primary" >
                                            <div className={classes.row}>
                                                <LocationOnOutlined /> <span> Delivery Address</span>
                                            </div>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} style={{ textAlign: 'right' }}>
                                        <Button color="primary" variant="contained" size="small" startIcon={<AddIcon />} onClick={() => addressToggle(true)}>
                                            Add Address
                                    </Button>
                                        <AddNewAddress
                                            isOpen={isAddressOpen}
                                            onClose={() => addressToggle(false)}
                                            isCheckOut={true}
                                            handleSubmit={(data) => {
                                                props.addAddress(data)
                                                handleAddress(data)
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                {
                                    props.meta.nearestOutlet.searchCompleted && !props.meta.nearestOutlet.id
                                    && (
                                        <Typography component="div" variant="h6" align="left" color="error" >
                                            Sorry, address not serviceable.
                                        </Typography>
                                    )
                                }
                                {
                                    props.meta.nearestOutlet.searchCompleted && props.meta.nearestOutlet.id && !props.outlets[props.meta.nearestOutlet.id].isOpen
                                    && (
                                        <Typography component="div" variant="h6" align="left" color="error" >
                                            Sorry, outlet currently not open.
                                        </Typography>
                                    )
                                }


                                <Grid container spacing={2} className={classes.marginTop}>
                                    {Array.isArray(props.profile.addresses) && props.profile.addresses.map(address => {
                                        const styleProps = {
                                            borderRadius: '20px',
                                            borderStyle: 'dashed',
                                            cursor: 'pointer'
                                        }

                                        if (state.selectedAddressId === address.id) {
                                            styleProps.borderStyle = 'solid'
                                            styleProps.borderColor = '#272727'
                                        }

                                        return (
                                            <Grid item xs={12} sm={6} md={6} key={address.id} id={address.id}>
                                                <Card variant="outlined" style={styleProps}
                                                    onClick={() => handleAddress(address)}
                                                >
                                                    <CardContent>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={11}>
                                                                <Typography>
                                                                    {address.doorNumber} {', '} {address.landmark}
                                                                </Typography>
                                                                <Typography color="textSecondary">
                                                                    {address.address}
                                                                </Typography>
                                                                <Typography>{address.phoneNumber}</Typography>
                                                                <Chip label={address.label} color="secondary" />
                                                            </Grid>
                                                            <Grid item xs={1}>
                                                                {
                                                                    state.selectedAddressId === address.id ? < CheckCircleIcon color="secondary" /> : <CheckCircleOutlineOutlinedIcon />
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        )

                                    })}
                                </Grid>

                            </CardContent>
                        </Card>

                        {/* ================================================== */}
                        {/* Address thing ends here */}
                        {/* ================================================== */}



                        {/* ================================================== */}
                        {/* Pay thing starts here */}
                        {/* ================================================== */}

                        {
                            !isEmpty(props.cart) && !isEmpty(state.address) && props.meta.nearestOutlet.id && props.outlets[props.meta.nearestOutlet.id].isOpen
                            && (
                                <Card variant="outlined" className={classes.card} >
                                    <CardContent>
                                        <Typography component="div" variant="h6" align="left" color="primary" >
                                            <div className={classes.row}>
                                                <AccountBalanceOutlined /> <span> Payment </span>
                                            </div>
                                        </Typography>
                                        <div className={classes.paymentDiv}>
                                            <Button color="secondary" variant="contained" size="large"
                                                startIcon={<CreditCardOutlined />}
                                                onClick={() => placeOrder(true)}
                                            >
                                                Pay Online
                                          </Button>

                                            <Typography component="div" variant="body1" align="left" color="primary" >
                                                or
                                        </Typography>

                                            <Button color="secondary" variant="contained" size="large"
                                                startIcon={<AccountBalanceWalletOutlined />}
                                                onClick={() => placeOrder(false)}
                                            >
                                                Pay with Cash
                                            </Button>
                                        </div>

                                    </CardContent>
                                </Card>
                            )
                        }

                        {/* ================================================== */}
                        {/* Pay thing ends here */}
                        {/* ================================================== */}

                    </Grid>
                    {/* ================================================== */}
                    {/* 1st column ends here */}
                    {/* ================================================== */}


                    {/* ================================================== */}
                    {/* 2nd column starts here */}
                    {/* ================================================== */}
                    <Grid item xs={12} sm={4}>
                        <Card variant="outlined" className={classes.card}>
                            <CardContent>
                                <Typography component="div" variant="h6" align="left" color="primary" className={classes.marginBottom} >
                                    <div className={classes.row}>
                                        <ShoppingCartOutlined /> <span> Your Cart : {props.qty} items </span>
                                    </div>
                                </Typography>
                                <Cart noSpace={true} />


                                {/* ================================================== */}
                                {/* promo code thing starts here */}
                                {/* ================================================== */}

                                {
                                    !isEmpty(props.cart) &&
                                    (
                                        <div className={classes.marginBottom}>
                                            {
                                                Boolean(state.promoCode) ?
                                                    <div className={classes.coupon}>
                                                        <LocalActivity />
                                                        <Typography component="span" variant="body1" align="left" color="primary">
                                                            {state.promoCode}
                                                        </Typography>
                                                        <Button size="small" variant="outlined" className={classes.couponRemove} onClick={() => { updatePrice(true) }}>
                                                            <Typography component="span" variant="body1" align="right" color="primary">
                                                                Remove
                                                    </Typography>
                                                        </Button>
                                                    </div>
                                                    :
                                                    <Button className={classes.coupon} fullWidth size="large" startIcon={<LocalActivity />} onClick={() => toggle(true)} >
                                                        <Typography component="span" variant="body1" align="left" color="primary">
                                                            VIEW/APPLY COUPONS
                                                </Typography>
                                                    </Button>
                                            }
                                            <OffersPopUp
                                                isOpen={isOpen}
                                                onClose={() => toggle(false)}
                                                price={props.price}
                                                isCheckOut={true}
                                                onSelect={(promoCode, promoId, discount) => { updatePrice(false, promoCode, promoId, discount) }}
                                            />
                                        </div>
                                    )
                                }

                                {/* ================================================== */}
                                {/* promo code thing ends here */}
                                {/* ================================================== */}


                                {/* ================================================== */}
                                {/* all amounts starts here */}
                                {/* ================================================== */}

                                {!isEmpty(props.cart) && (<Table>
                                    <TableBody>
                                        <TableRow>
                                            <CustomTableCell aria-label="" align='left'>Item Price</CustomTableCell>
                                            <CustomTableCell aria-label="" align='right'>₹{Number(props.price).toFixed(2)}</CustomTableCell>
                                        </TableRow>
                                        {state.discount > 0 && (<TableRow>
                                            <CustomTableCell aria-label="" align='left' className={classes.discount}>Discount</CustomTableCell>
                                            <CustomTableCell aria-label="" align='right' className={classes.discount}>- ₹{Number(state.discount).toFixed(2)}</CustomTableCell>
                                        </TableRow>)}
                                        <TableRow>
                                            <CustomTableCell aria-label="" align='left'>Packaging Charge</CustomTableCell>
                                            <CustomTableCell aria-label="" align='right'>+ ₹{Number(state.packagingCharge).toFixed(2)}</CustomTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <CustomTableCell aria-label="" align='left'>Delivery Charge</CustomTableCell>
                                            <CustomTableCell aria-label="" align='right'>+ ₹{Number(state.deliveryCharge).toFixed(2)}</CustomTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <CustomTableCell aria-label="" align='left'>GST {Number(state.gst)}%</CustomTableCell>
                                            <CustomTableCell aria-label="" align='right'>
                                                + ₹{(Number(props.price) * (Number(state.gst)) / 100).toFixed(2)}
                                            </CustomTableCell>
                                        </TableRow>
                                        <TableRow className={classes.payable}>
                                            <CustomTableCell aria-label="" align='left'>
                                                <Typography component="span" variant="h6" align="left" color="primary">Payable</Typography>
                                            </CustomTableCell>
                                            <CustomTableCell aria-label="" align='right'>
                                                <Typography component="span" variant="h6" align="right" color="primary">₹{Number(state.payable).toFixed(2)}</Typography>
                                            </CustomTableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>)}

                                {/* ================================================== */}
                                {/* all amounts ends here */}
                                {/* ================================================== */}

                            </CardContent>
                        </Card>
                    </Grid>
                    {/* ================================================== */}
                    {/* 2nd column ends here */}
                    {/* ================================================== */}
                </Grid>
            </Container>
        </div>
    )

}

const mapSateToProps = (state) => {
    const { cart, profile, uid } = state.user
    const { meta, outlets, promoCodes } = state
    let qty = 0, price = 0;

    for (let key in cart) {

        const itemArray = cart[key]
        for (let i = 0; i < itemArray.length; i++) {
            const config = itemArray[i]
            const configQty = parseInt(config.quantity);
            qty += configQty;
            const configPrice = parseInt(config.totalPrice);
            price = price + (parseInt(configPrice) * configQty)
        }
    }

    const isPorfileComplete = Boolean(profile.full_name) && Boolean(profile.email)

    return { price, qty, meta, profile, outlets, cart, uid, promoCodes, isPorfileComplete }
}

export default connect(mapSateToProps, { addAddress, createOrder, setLocation, openUpdateProfileModal, closeUpdateProfileModal })(CheckOut)